'use client';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { tradeApi } from '../api/trade.api';

export const TRADE_QUERY_KEYS = {
  all: ['trade'] as const,
  orders: () => [...TRADE_QUERY_KEYS.all, 'orders'] as const,
  order: (id: string) => [...TRADE_QUERY_KEYS.all, 'order', id] as const,
};

export const usePlaceOrder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: tradeApi.placeOrder,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TRADE_QUERY_KEYS.orders() });
    },
  });
};

export const useOrders = () => {
  return useQuery({
    queryKey: TRADE_QUERY_KEYS.orders(),
    queryFn: tradeApi.getOrders,
  });
};

export const useOrderStatus = (orderId: string) => {
  return useQuery({
    queryKey: TRADE_QUERY_KEYS.order(orderId),
    queryFn: () => tradeApi.getOrderStatus(orderId),
    enabled: !!orderId,
  });
};

export const useCancelOrder = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: tradeApi.cancelOrder,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TRADE_QUERY_KEYS.orders() });
    },
  });
};

export const useCancelAllOrders = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: tradeApi.cancelAllOrders,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TRADE_QUERY_KEYS.orders() });
    },
  });
};
